import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { RadioGroupFieldWUT } from '../../../ui/radio-group-field';
export const RadioGroupWUT = (props)=>{
    const { fieldType = FIELD_TYPES.RADIO_GROUP } = props;
    return /*#__PURE__*/ React.createElement(RadioGroupFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=radio-group-wut.js.map